import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaBancosLayoutLista', {
    template: template,
    controller: NominasNominaBancosLayoutListaComponent,
    bindings: {
      valido: '<',
      onSeleccionar: '&',
      data: '<',
    },
  })

function NominasNominaBancosLayoutListaComponent() {
  let $ctrl = this

  $ctrl.seleccionar = seleccionar
  $ctrl.seleccionados = []

  function seleccionar(item) {
    if (item === true) {
      $ctrl.data.forEach(function (item) {
        item.$$selected = true
      })
    } else if (item === false) {
      $ctrl.data.forEach(function (item) {
        item.$$selected = false
      })
    } else {
      item.$$selected = !item.$$selected
    }

    $ctrl.seleccionados = $ctrl.data.filter(function (item) {
      return item.$$selected
    })

    $ctrl.onSeleccionar({items: $ctrl.seleccionados})
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/layout/lista/component.js